// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarLogoFade-enter-active[data-v-6494804b] {
  transition: opacity 1.5s;
}
.sidebarLogoFade-enter[data-v-6494804b],
.sidebarLogoFade-leave-to[data-v-6494804b] {
  opacity: 0;
}
.sidebar-logo-container[data-v-6494804b] {
  position: relative;
  width: 100%;
  height: 65px;
  line-height: 50px;
  background: #061026;
  text-align: center;
  overflow: hidden;
  padding: 10px;
}
.sidebar-logo-container .sidebar-logo-link[data-v-6494804b] {
  height: 100%;
  width: 100%;
}
.sidebar-logo-container .sidebar-logo-link .sidebar-logo[data-v-6494804b] {
  width: 100%;
  height: auto;
  vertical-align: middle;
  margin-top: 0;
}
.sidebar-logo-container .sidebar-logo-link .sidebar-logo.simbolo[data-v-6494804b] {
  width: 3rem;
}
.sidebar-logo-container .sidebar-logo-link .sidebar-title[data-v-6494804b] {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  line-height: 50px;
  font-size: 14px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
}
.sidebar-logo-container.collapse .sidebar-logo[data-v-6494804b] {
  margin-right: 0px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
